module.exports = __webpack_public_path__ + "static/gearing-cc4206ffa69bdeb12cddd66f93847b72.svg";